import React, { FC } from 'react';
import './index.less';

const Header: FC = (props) => {
  return (
    <div>
      <div style={{ height: 64 }} />
      <header className="gc-header">{props.children}</header>
    </div>
  );
};

export default Header;
